export const scrollIntoView = (el: HTMLElement | null): void => {
  if (!el) {
    return
  }

  const elementPosition = el.offsetTop
  const direction = elementPosition > window.scrollY ? "down" : "up"
  const header = document.querySelector("[data-js=header]")
  const headerHeight = header!.clientHeight
  const offset = 10

  const offsetPosition =
    direction === "up" || elementPosition === window.scrollY + offset
      ? elementPosition - offset
      : elementPosition + headerHeight - offset

  window.scrollTo({ top: offsetPosition, behavior: "smooth" })
}
